export const SANS_TYPE_VENTE = 0;
export const TYPE_VENTE_FULL = 100;
export const TYPE_VENTE_ACCESS = 200;
export const GRANULARITY_DAY = 'day';
export const GRANULARITY_WEEK = 'week';
export const GRANULARITY_MONTH = 'month';
export const GRANULARITY_3MONTH = 'month3';
export const GRANULARITY_YEAR = 'year';

export const GRANULARITY = {
  day: {
    granularity: GRANULARITY_DAY,
    label: 'Jours',
    value: 0,
    actif: true,
  },
  week: {
    granularity: GRANULARITY_WEEK,
    label: 'Semaines',
    value: 1,
    actif: true,
  },
  month: {
    granularity: GRANULARITY_MONTH,
    label: 'Mois',
    value: 2,
    actif: false,
  },
  month3: {
    granularity: GRANULARITY_3MONTH,
    label: '3 Mois',
    value: 4,
    actif: false,
  },
  year: {
    granularity: GRANULARITY_YEAR,
    label: 'Années',
    value: 3,
    actif: false,
  },
};

export const TYPE_TARIFICATION = [{
  value: SANS_TYPE_VENTE,
  libelle: '',
},
{
  value: TYPE_VENTE_FULL + GRANULARITY[GRANULARITY_DAY].value,
  libelle: 'Jour full',
  typeVente: TYPE_VENTE_FULL,
  granularity: GRANULARITY_DAY,
  refProduit: 'FULL1Jour',
},
{
  value: TYPE_VENTE_ACCESS + GRANULARITY[GRANULARITY_DAY].value,
  libelle: 'Jour (1 boucle / 2)',
  typeVente: TYPE_VENTE_ACCESS,
  granularity: GRANULARITY_DAY,
  refProduit: 'ACCESS1Jour',
},
{
  value: TYPE_VENTE_FULL + GRANULARITY[GRANULARITY_WEEK].value,
  libelle: 'Semaine full',
  typeVente: TYPE_VENTE_FULL,
  granularity: GRANULARITY_WEEK,
  refProduit: 'FULL1Semaine',
},
{
  value: TYPE_VENTE_ACCESS + GRANULARITY[GRANULARITY_WEEK].value,
  libelle: 'Semaine (1 boucle / 2)',
  typeVente: TYPE_VENTE_ACCESS,
  granularity: GRANULARITY_WEEK,
  refProduit: 'ACCESS1Semaine',
},
{
  value: TYPE_VENTE_FULL + GRANULARITY[GRANULARITY_MONTH].value,
  libelle: 'Mois full',
  typeVente: TYPE_VENTE_FULL,
  granularity: GRANULARITY_MONTH,
  refProduit: 'FULL1Mois',
},
{
  value: TYPE_VENTE_ACCESS + GRANULARITY[GRANULARITY_MONTH].value,
  libelle: 'Mois (1 boucle / 2)',
  typeVente: TYPE_VENTE_ACCESS,
  granularity: GRANULARITY_MONTH,
  refProduit: 'ACCESS1Mois',
},
{
  value: TYPE_VENTE_FULL + GRANULARITY[GRANULARITY_3MONTH].value,
  libelle: '3 Mois full',
  typeVente: TYPE_VENTE_FULL,
  granularity: GRANULARITY_MONTH,
  refProduit: 'FULL3Mois',
},
{
  value: TYPE_VENTE_ACCESS + GRANULARITY[GRANULARITY_3MONTH].value,
  libelle: '3 Mois (1 boucle / 2)',
  typeVente: TYPE_VENTE_ACCESS,
  granularity: GRANULARITY_MONTH,
  refProduit: 'ACCESS3Mois',
},
{
  value: TYPE_VENTE_FULL + GRANULARITY[GRANULARITY_YEAR].value,
  libelle: 'Année full',
  typeVente: TYPE_VENTE_FULL,
  granularity: GRANULARITY_YEAR,
  refProduit: 'FULL1Annee',
},
{
  value: TYPE_VENTE_ACCESS + GRANULARITY[GRANULARITY_YEAR].value,
  libelle: 'Année (1 boucle / 2)',
  typeVente: TYPE_VENTE_ACCESS,
  granularity: GRANULARITY_YEAR,
  refProduit: 'ACCESS1Annee',
},
];



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/planningNumeriqueConf.js